"use client";
import { LiveSharePage } from "@highway/design-system";

export default function LiveShare() {
    return (
        <>
            <title>Buy vs Rent</title>
            <LiveSharePage
                tool="bvr"
                baseUrl="buy-vs-rent"
                renderHeaderText={({ clientName }) => `Buy vs Rent for ${clientName}`}
                renderButtonText={({ isMeeting }) => (isMeeting ? "View report" : "View flyer")}
                hasReportRoute
            />
        </>
    );
}
